// R1/AC-2 — the atomic Target-step selection update. Extracted into a small, pure,
// importable function so both TargetContainerStep callers (PipelineWizard's Formik
// `setValues` and PipelineEditDialog's `useState` `setValues`) apply the EXACT same rule,
// and so it is independently unit-testable (TC-DPDF-027) without mounting Formik, the
// wizard, or the Edit dialog.
//
// Root cause this replaces (see spec §Problem): calling `setFieldValue('AppInstanceId', …)`
// then `setFieldValue('ContainerAppId', '')` as two sequential Formik calls re-validates
// against the stale render-closure `values` on the second call, leaving a false
// `errors.AppInstanceId`. A single atomic object update (via the updater form at the call
// site) avoids that entirely — this helper is the "next values" half of that atomic update.
export const computeTargetSelectionUpdate = (values, appInstanceId) => ({
	...values,
	AppInstanceId: appInstanceId ?? '',
	ContainerAppId: ''
});

export default computeTargetSelectionUpdate;
